'use client'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { storeInfoMenuItems } from '@/data/menu'

export default function StoreInfoNav() {
  const pathname = usePathname()

  return (
    <div className="col-lg-3 store-info-nav">
      {/* 不換行 + 超出顯示 …；並且可選擇加寬側欄避免太容易被截斷 */}
      <style jsx>{`
        .store-info-nav {
          /* 可依需要調整側欄最小寬度，避免太窄時一直出現省略號 */
          min-width: 220px;
        }
        .account-nav .menu-link {
          display: block;
          max-width: 100%;
          white-space: nowrap; /* 不換行 */
          word-break: keep-all; /* 儘量不斷詞（CJK 友善） */
          overflow: hidden; /* 超出隱藏 */
          text-overflow: ellipsis; /* 超出顯示 … */
        }
      `}</style>

      <ul className="account-nav">
        {storeInfoMenuItems.map((item, i) => {
          const isActive =
            pathname === item.href || pathname.startsWith(item.href + '/')

          return (
            <li key={i}>
              <Link
                href={item.href}
                title={item.title} /* 滑過時可看到完整文字 */
                aria-current={isActive ? 'page' : undefined}
                className={`menu-link menu-link_us-s ${
                  isActive ? 'menu-link_active' : ''
                }`}
              >
                {item.title}
              </Link>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
